/**
 * Datasets Service
 * Handles API calls for dataset operations including public sharing.
 */
import API from './api.ts';

// Get all datasets (user's own + added)
export async function getAllDatasets() {
  const response = await API.get(`/datasets/`);
  return response.data;
}

// Get public datasets (for Open Medical Datasets page)
export async function getPublicDatasets() {
  const response = await API.get(`/datasets/`, {
    params: { public: 'true' }
  });
  return response.data;
}

// Get dataset by ID
export async function getDataset(datasetId) {
  const response = await API.get(`/datasets/${datasetId}/`);
  return response.data;
}

// Get datasets for a project
export async function getDatasetsForProject(projectId) {
  const response = await API.get(`/datasets/`, {
    params: { project: projectId }
  });
  return response.data;
}

// Get datasets for a study
export async function getDatasetsForStudy(studyId) {
  const response = await API.get(`/datasets/`, {
    params: { study: studyId }
  });
  return response.data;
}

// Toggle dataset public visibility
// Optional: pass allow_download when making a dataset public
export async function toggleDatasetPublic(datasetId, allowDownload = null) {
  const data = {};
  if (allowDownload !== null) {
    data.allow_download = allowDownload;
  }
  const response = await API.post(`/datasets/${datasetId}/toggle-public/`, data);
  return response.data;
}

// Update download permission for a dataset
export async function updateDownloadPermission(datasetId, allowDownload) {
  const response = await API.post(`/datasets/${datasetId}/update-download-permission/`, {
    allow_download: allowDownload
  });
  return response.data;
}

// Add public dataset to user's datasets
export async function addDatasetToMyDatasets(datasetId) {
  const response = await API.post(`/datasets/${datasetId}/add-to-my-datasets/`);
  return response.data;
}

// Remove dataset from user's datasets
export async function removeDatasetFromMyDatasets(datasetId) {
  const response = await API.post(`/datasets/${datasetId}/remove-from-my-datasets/`);
  return response.data;
}

// Assign dataset to study
export async function assignDatasetToStudy(datasetId, studyId) {
  const response = await API.post(`/datasets/${datasetId}/assign-to-study/`, {
    study_id: studyId
  });
  return response.data;
}

// Create a new dataset
export async function createDataset(data) {
  const response = await API.post(`/datasets/`, data);
  return response.data;
}

// Update a dataset
export async function updateDataset(datasetId, data) {
  const response = await API.patch(`/datasets/${datasetId}/`, data);
  return response.data;
}

// Delete a dataset
export async function deleteDataset(datasetId) {
  const response = await API.delete(`/datasets/${datasetId}/`);
  return response.data;
}

export default {
  getAllDatasets,
  getPublicDatasets,
  getDataset,
  getDatasetsForProject,
  getDatasetsForStudy,
  toggleDatasetPublic,
  updateDownloadPermission,
  addDatasetToMyDatasets,
  removeDatasetFromMyDatasets,
  assignDatasetToStudy,
  createDataset,
  updateDataset,
  deleteDataset,
};
